import axios from 'axios'

import { parseFileExtension } from '@app/lib/mime'
import { requireAuthToken } from '@app/modules/Auth/resolveAuthToken'
import { AttachDocumentToLawyerMessageMutationFn } from '@app/queries/AttachDocumentToLawyerMessage/AttachDocumentToLawyerMessage.queries'
import SDK from '@app/SDK'

export type UploadFilesProps = {
  files: File[]
  messageId?: number
  attachDocumentToLawyerMessageMutation?: AttachDocumentToLawyerMessageMutationFn
}

export const uploadFiles = async ({
  files,
  messageId,
  attachDocumentToLawyerMessageMutation
}: UploadFilesProps) => {
  const documentIds: Array<number> = []
  const token = await requireAuthToken()

  const uploadPromises = files.map(async (file) => {
    const { documentId, signedUrl, headers } = await SDK.documentAnalyzer.authorizeLawyerUpload({
      token,
      file: {
        fileExtension: parseFileExtension(file.name, file.type),
        fileName: file.name
      }
    })

    await axios.put(signedUrl, file, {
      headers: {
        'Content-Type': file.type,
        ...headers
      }
    })

    documentIds.push(documentId)

    if (!messageId || !attachDocumentToLawyerMessageMutation) return

    await attachDocumentToLawyerMessageMutation({
      variables: { documentId, messageId }
    })
  })

  await Promise.all(uploadPromises)

  return documentIds
}
